import { CreatorProfile, MarketplaceItem, MarketplaceMetadata, MarketplaceReview, User } from "../../types/marketplace";
let listOfPros = ['Very nice looking', 'Simple to use', 'Simple to integrate','Helpful tool','Good price','Interessting style','Fast performance',
  'Responsive support team','Regular updates','Customizable options','Lightweight installation','Cross-platform compatibility'];
let listOfCons = ['Expensive','Hard to understand', 'Usage is not intuative', 'Unstyled passages', 'Missplaced items','Limited documentation',
  'Occasional bugs','Slow loading times on older devices','Few advanced features','Inconsistent design elements']

  // Example User
let exampleUser1: User = {
    id: '0',
    username: 'Tim Hartmann',
    displayName: 'Timmy0892',
    avatar: '',
};
let exampleUser2: User = {
    id: '1',
    username: 'Ana Maria Li',
    displayName: 'Ana',
    avatar: '',
};
let exampleUser3: User = {
    id: '2',
    username: 'Karina Katze',
    displayName: 'Karina',
    avatar: '',
};
let exampleUser4: User = {
    id: '3',
    username: 'Klaus Rüttler',
    displayName: 'Klausky',
    avatar: '',
};
let exampleUser5: User = {
    id: '4',
    username: 'Gregor Gysi',
    displayName: 'Gregor',
    avatar: '',
};
let exampleUser6: User = {
    id: '5',
    username: 'Marie Kunze',
    displayName: 'Marybird',
    avatar: '',
};
let exampleUser7: User = {
    id: '6',
    username: 'Ulla Ulrich',
    displayName: 'Ulla',
    avatar: '',
};
let exampleUser8: User = {
    id: '7',
    username: 'Jana Meyers',
    displayName: 'fluffyUnicorn',
    avatar: '',
};

//Example Reviews
let exampleReview1:MarketplaceReview = {
    id: '0',
    itemId: '0',
    reviewerId: '0',
    reviewer: exampleUser1,
    rating: 1,
    title: 'Stylish App with Room for Improvement',
    comment: 'The application offers a good price and has an interesting, unique style that sets it apart from others. However, it can be hard to understand at first, and the overall usage isn’t very intuitive. With some improvements to usability, it could become a much better experience.',
    pros: [listOfPros[3],listOfPros[4]],
    cons: [listOfCons[1], listOfCons[2]],
    isVerified: true,
    helpfulVotes: 4,
    createdAt: new Date()
};
let exampleReview2 = {
  id: '1',
  itemId: '0',
  reviewerId: '1',
  reviewer: exampleUser2,
  rating: 4,
  title: 'Clean Design and Easy Setup',
  comment: 'I love how simple it was to integrate this app into my workflow. The interface looks great and the installation was lightweight. Perfect for quick setups.',
  pros: [listOfPros[0], listOfPros[2], listOfPros[10]],
  cons: [listOfCons[9]],
  isVerified: true,
  helpfulVotes: 7,
  createdAt: new Date()
};
let exampleReview3 = {
  id: '2',
  itemId: '0',
  reviewerId: '2',
  reviewer: exampleUser3,
  rating: 4,
  title: 'Nice Look, but Lacks Depth',
  comment: 'It’s a very nice-looking app, and I appreciate the regular updates. Sadly, it feels limited in terms of advanced features, and the documentation could be better.',
  pros: [listOfPros[0], listOfPros[8]],
  cons: [listOfCons[6], listOfCons[8]],
  isVerified: true,
  helpfulVotes: 5,
  createdAt: new Date()
};
let exampleReview4 = {
  id: '3',
  itemId: '0',
  reviewerId: '3',
  reviewer: exampleUser4,
  rating: 3,
  title: 'Good Tool for Small Teams',
  comment: 'This tool helped our small team organize tasks more effectively. It’s fast and the support team is very responsive. However, it’s quite pricey for the feature set.',
  pros: [listOfPros[3], listOfPros[6], listOfPros[7]],
  cons: [listOfCons[0]],
  isVerified: true,
  helpfulVotes: 6,
  createdAt: new Date()
};
let exampleReview5 = {
  id: '4',
  itemId: '0',
  reviewerId: '4',
  reviewer: exampleUser5,
  rating: 5,
  title: 'Good Ideas, Poor Execution',
  comment: 'The concept is great, and I like the customizable options, but the layout feels inconsistent and there are a few misplaced items. Needs refinement.',
  pros: [listOfPros[9]],
  cons: [listOfCons[4], listOfCons[9]],
  isVerified: true,
  helpfulVotes: 3,
  createdAt: new Date()
};

let exampleReview6 = {
  id: '5',
  itemId: '0',
  reviewerId: '5',
  reviewer: exampleUser6,
  rating: 5,
  title: 'Smooth and Reliable',
  comment: 'I’ve had a great experience so far! The app performs fast, works across platforms, and the updates keep improving it. Highly recommended.',
  pros: [listOfPros[6], listOfPros[8], listOfPros[11]],
  cons: [],
  isVerified: true,
  helpfulVotes: 10,
  createdAt: new Date()
};
let exampleReview7 = {
  id: '6',
  itemId: '0',
  reviewerId: '6',
  reviewer: exampleUser7,
  rating: 4,
  title: 'Mixed Feelings',
  comment: 'While the style and price are appealing, I found some parts hard to understand and the navigation isn’t very intuitive. Could be easier for beginners.',
  pros: [listOfPros[4], listOfPros[5]],
  cons: [listOfCons[1], listOfCons[2]],
  isVerified: true,
  helpfulVotes: 2,
  createdAt: new Date()
};
let exampleReview8 = {
  id: '7',
  itemId: '0',
  reviewerId: '7',
  reviewer: exampleUser8,
  rating: 5,
  title: 'Beautiful Interface and Great Support',
  comment: 'The app looks beautiful, runs smoothly, and the support team is quick to respond. It’s a bit expensive, but I think it’s worth it.',
  pros: [listOfPros[0], listOfPros[7], listOfPros[6]],
  cons: [listOfCons[0]],
  isVerified: true,
  helpfulVotes: 8,
  createdAt: new Date()
};
let exampleReview9 = {
  id: '8',
  itemId: '0',
  reviewerId: '1',
  reviewer: exampleUser2,
  rating: 3,
  title: 'Decent but Needs Optimization',
  comment: 'I like the app’s clean style and simple setup, but it slows down on older devices and sometimes bugs appear during use.',
  pros: [listOfPros[1], listOfPros[5]],
  cons: [listOfCons[6], listOfCons[7]],
  isVerified: false,
  helpfulVotes: 4,
  createdAt: new Date()
};
let exampleReview10 = {
  id: '9',
  itemId: '0',
  reviewerId: '2',
  reviewer: exampleUser3,
  rating: 4,
  title: 'Good Value and Features',
  comment: 'For the price, this app offers a solid set of features and runs efficiently. A few parts of the UI could be clearer, but overall it’s worth it.',
  pros: [listOfPros[4], listOfPros[6]],
  cons: [listOfCons[1]],
  isVerified: true,
  helpfulVotes: 5,
  createdAt: new Date()
};
let exampleReview11 = {
  id: '10',
  itemId: '0',
  reviewerId: '5',
  reviewer: exampleUser6,
  rating: 3,
  title: 'Nice Start but Needs Polish',
  comment: 'It’s simple to use and looks great, but I noticed some unstyled passages and missing polish in the design. Promising, though.',
  pros: [listOfPros[0], listOfPros[1]],
  cons: [listOfCons[3], listOfCons[9]],
  isVerified: true,
  helpfulVotes: 3,
  createdAt: new Date()
};

// Example Creator profiles
let exampleUserCreatorProfile1: CreatorProfile = {
    id: '0',
    username: 'Tim Hartmann',
    displayName: 'Timmy0892',
    avatar: '',
    bio: 'Professional Developer with passion',
    socialLinks: [],
    totalDownloads: 96,
    totalRating: 120,
    itemCount: 4,
    totalEarnings: 203.34,
    joinedDate: new Date(),
    isVerified: true,
    specializations: ['AI', 'PDF','Excel']
};
let exampleUserCreatorProfile2 = {
  id: '1',
  username: 'Ana Maria Li',
  displayName: 'Ana',
  avatar: '',
  bio: 'Designer and app enthusiast focused on clean UI and UX.',
  socialLinks: [],
  totalDownloads: 142,
  totalRating: 135,
  itemCount: 6,
  totalEarnings: 318.75,
  joinedDate: new Date(),
  isVerified: true,
  specializations: ['UI/UX', 'Frontend', 'Web Design']
};
let exampleUserCreatorProfile3 = {
  id: '2',
  username: 'Karina Katze',
  displayName: 'Karina',
  avatar: '',
  bio: 'Creative thinker with a love for automation and visual tools.',
  socialLinks: [],
  totalDownloads: 87,
  totalRating: 98,
  itemCount: 3,
  totalEarnings: 176.20,
  joinedDate: new Date(),
  isVerified: false,
  specializations: ['Automation', 'No-Code', 'Graphics']
};
let exampleUserCreatorProfile4 = {
  id: '3',
  username: 'Klaus Rüttler',
  displayName: 'Klausky',
  avatar: '',
  bio: 'Backend engineer focused on performance and reliability.',
  socialLinks: [],
  totalDownloads: 211,
  totalRating: 190,
  itemCount: 8,
  totalEarnings: 502.80,
  joinedDate: new Date(),
  isVerified: true,
  specializations: ['Backend', 'API', 'Database']
};
let exampleUserCreatorProfile5 = {
  id: '4',
  username: 'Gregor Gysi',
  displayName: 'Gregor',
  avatar: '',
  bio: 'Tech enthusiast building smart productivity tools.',
  socialLinks: [],
  totalDownloads: 65,
  totalRating: 77,
  itemCount: 2,
  totalEarnings: 94.50,
  joinedDate: new Date(),
  isVerified: false,
  specializations: ['Productivity', 'Automation', 'PDF']
};
let exampleUserCreatorProfile6 = {
  id: '5',
  username: 'Marie Kunze',
  displayName: 'Marybird',
  avatar: '',
  bio: 'Passionate developer crafting user-friendly digital experiences.',
  socialLinks: [],
  totalDownloads: 154,
  totalRating: 143,
  itemCount: 5,
  totalEarnings: 349.10,
  joinedDate: new Date(),
  isVerified: true,
  specializations: ['Frontend', 'Web Apps', 'AI']
};
let exampleUserCreatorProfile7 = {
  id: '6',
  username: 'Ulla Ulrich',
  displayName: 'Ulla',
  avatar: '',
  bio: 'Content creator blending creativity and technology.',
  socialLinks: [],
  totalDownloads: 112,
  totalRating: 102,
  itemCount: 4,
  totalEarnings: 224.75,
  joinedDate: new Date(),
  isVerified: false,
  specializations: ['Design', 'Templates', 'Marketing']
};
let exampleUserCreatorProfile8 = {
  id: '7',
  username: 'Jana Meyers',
  displayName: 'fluffyUnicorn',
  avatar: '',
  bio: 'Creative developer with a flair for unique visuals and tools.',
  socialLinks: [],
  totalDownloads: 189,
  totalRating: 165,
  itemCount: 7,
  totalEarnings: 415.95,
  joinedDate: new Date(),
  isVerified: true,
  specializations: ['Graphics', 'UI/UX', 'Branding']
};

export let exampleMarketPlaceItem1: MarketplaceItem = {
    id: '0',
    type: 'workflow',
    title: 'Smart Automation Workflow',
    description: 'Automate repetitive tasks with this smart workflow.',
    authorId: '0',
    author: exampleUserCreatorProfile1,
    category: 'automation',
    tags: ['AI','PDF','Productivity'],
    thumbnail: '',
    screenshots: [],
    price: 0,
    isPremium: false,
    rating: 5,
    ratingCount: 1,
    downloadCount: 8,
    viewCount: 45,
    reviews: [exampleReview1, exampleReview5],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-02-01'),
    publishedAt: new Date('2025-02-01'),
    metadata: {
      version: 'v1.0.0',
      compatibility: ['Windows','Mac'],
      fileSize: 25,
      lastModified: new Date('2025-02-01')
    }
  }
export let exampleMarketPlaceItem2: MarketplaceItem =  {
    id: '1',
    type: 'template',
    title: 'Minimalist UI Template',
    description: 'Clean and simple UI template for web apps.',
    authorId: '1',
    author: exampleUserCreatorProfile2,
    category: 'design',
    tags: ['UI','UX','Frontend'],
    thumbnail: '',
    screenshots: [],
    price: 19.99,
    isPremium: true,
    rating: 4,
    ratingCount: 2,
    downloadCount: 15,
    viewCount: 60,
    reviews: [exampleReview2, exampleReview9],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-02-15'),
    updatedAt: new Date('2025-03-01'),
    publishedAt: new Date('2025-03-01'),
    metadata: {
      version: 'v2.1',
      compatibility: ['Windows','Linux','Mac'],
      fileSize: 35,
      lastModified: new Date('2025-03-01')
    }
  };
export let exampleMarketPlaceItem3: MarketplaceItem ={
    id: '2',
    type: 'node',
    title: 'Data Processing Node',
    description: 'Process large datasets efficiently with this node.',
    authorId: '2',
    author: exampleUserCreatorProfile3,
    category: 'data',
    tags: ['Automation','No-Code','Analytics'],
    thumbnail: '',
    screenshots: [],
    price: 5.5,
    isPremium: false,
    rating: 3,
    ratingCount: 1,
    downloadCount: 12,
    viewCount: 30,
    reviews: [exampleReview3],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-03-12'),
    updatedAt: new Date('2025-03-20'),
    publishedAt: new Date('2025-03-20'),
    metadata: {
      version: 'v1.5',
      compatibility: ['Mac'],
      fileSize: 12,
      lastModified: new Date('2025-03-20')
    }
  };
export let exampleMarketPlaceItem4: MarketplaceItem = {
    id: '3',
    type: 'workflow',
    title: 'Team Collaboration Workflow',
    description: 'Enhance productivity for small teams.',
    authorId: '3',
    author: exampleUserCreatorProfile4,
    category: 'productivity',
    tags: ['Backend','API','Tasks'],
    thumbnail: '',
    screenshots: [],
    price: 24.99,
    isPremium: true,
    rating: 5,
    ratingCount: 2,
    downloadCount: 20,
    viewCount: 55,
    reviews: [exampleReview4, exampleReview7],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-01-25'),
    updatedAt: new Date('2025-02-05'),
    publishedAt: new Date('2025-02-05'),
    metadata: {
      version: 'v3.0',
      compatibility: ['Windows','Linux'],
      fileSize: 40,
      lastModified: new Date('2025-02-05')
    }
  }
export let exampleMarketPlaceItem5: MarketplaceItem =  {
    id: '4',
    type: 'template',
    title: 'Productivity Dashboard',
    description: 'Organize tasks, deadlines, and projects in one dashboard.',
    authorId: '4',
    author: exampleUserCreatorProfile5,
    category: 'productivity',
    tags: ['PDF','Automation','Tools'],
    thumbnail: '',
    screenshots: [],
    price: 9.99,
    isPremium: false,
    rating: 3,
    ratingCount: 1,
    downloadCount: 10,
    viewCount: 25,
    reviews: [exampleReview5],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-04-01'),
    updatedAt: new Date('2025-04-10'),
    publishedAt: new Date('2025-04-10'),
    metadata: {
      version: 'v1.0',
      compatibility: ['Windows','Mac'],
      fileSize: 20,
      lastModified: new Date('2025-04-10')
    }
  };
export let exampleMarketPlaceItem6: MarketplaceItem = {
    id: '5',
    type: 'node',
    title: 'Fast Performance Node',
    description: 'Optimized node for speed-critical tasks.',
    authorId: '5',
    author: exampleUserCreatorProfile6,
    category: 'performance',
    tags: ['Frontend','Web Apps','AI'],
    thumbnail: '',
    screenshots: [],
    price: 14.5,
    isPremium: true,
    rating: 5,
    ratingCount: 2,
    downloadCount: 18,
    viewCount: 40,
    reviews: [exampleReview6, exampleReview10],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-02-28'),
    updatedAt: new Date('2025-03-15'),
    publishedAt: new Date('2025-03-15'),
    metadata: {
      version: 'v2.0',
      compatibility: ['Windows','Mac','Linux'],
      fileSize: 30,
      lastModified: new Date('2025-03-15')
    }
  };
export let exampleMarketPlaceItem7: MarketplaceItem = {
    id: '6',
    type: 'workflow',
    title: 'Beginner Friendly Workflow',
    description: 'Easy to use workflow for beginners.',
    authorId: '6',
    author: exampleUserCreatorProfile7,
    category: 'education',
    tags: ['Design','Templates','Learning'],
    thumbnail: '',
    screenshots: [],
    price: 7.99,
    isPremium: false,
    rating: 4,
    ratingCount: 2,
    downloadCount: 14,
    viewCount: 33,
    reviews: [exampleReview7],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-03-10'),
    updatedAt: new Date('2025-03-18'),
    publishedAt: new Date('2025-03-18'),
    metadata: {
      version: 'v1.2',
      compatibility: ['Mac'],
      fileSize: 15,
      lastModified: new Date('2025-03-18')
    }
  };
export let exampleMarketPlaceItem8: MarketplaceItem = {
    id: '7',
    type: 'template',
    title: 'Beautiful Interface Kit',
    description: 'Enhance your apps with this UI kit.',
    authorId: '7',
    author: exampleUserCreatorProfile8,
    category: 'design',
    tags: ['Graphics','UI/UX','Branding'],
    thumbnail: '',
    screenshots: [],
    price: 22.5,
    isPremium: true,
    rating: 3,
    ratingCount: 2,
    downloadCount: 21,
    viewCount: 48,
    reviews: [exampleReview8, exampleReview11],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-04-05'),
    updatedAt: new Date('2025-04-20'),
    publishedAt: new Date('2025-04-20'),
    metadata: {
      version: 'v2.5',
      compatibility: ['Windows','Linux','Mac'],
      fileSize: 45,
      lastModified: new Date('2025-04-20')
    }
  };
export let exampleMarketPlaceItem9: MarketplaceItem = {
    id: '8',
    type: 'node',
    title: 'Optimized Analytics Node',
    description: 'Analyze large datasets with high efficiency.',
    authorId: '0',
    author: exampleUserCreatorProfile1,
    category: 'analytics',
    tags: ['AI','PDF','Excel'],
    thumbnail: '',
    screenshots: [],
    price: 18,
    isPremium: true,
    rating: 4,
    ratingCount: 1,
    downloadCount: 12,
    viewCount: 28,
    reviews: [exampleReview1],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-02-05'),
    updatedAt: new Date('2025-02-18'),
    publishedAt: new Date('2025-02-18'),
    metadata: {
      version: 'v1.1',
      compatibility: ['Windows','Mac'],
      fileSize: 28,
      lastModified: new Date('2025-02-18')
    }
  }
export let exampleMarketPlaceItem10: MarketplaceItem = {
    id: '9',
    type: 'workflow',
    title: 'Advanced AI Workflow',
    description: 'Automate AI tasks and processes seamlessly.',
    authorId: '1',
    author: exampleUserCreatorProfile2,
    category: 'AI',
    tags: ['Frontend','UI','UX'],
    thumbnail: '',
    screenshots: [],
    price: 25,
    isPremium: true,
    rating: 3,
    ratingCount: 2,
    downloadCount: 22,
    viewCount: 50,
    reviews: [exampleReview2],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-03-05'),
    updatedAt: new Date('2025-03-22'),
    publishedAt: new Date('2025-03-22'),
    metadata: {
      version: 'v2.2',
      compatibility: ['Windows','Linux','Mac'],
      fileSize: 36,
      lastModified: new Date('2025-03-22')
    }
  };
export let exampleMarketPlaceItem11: MarketplaceItem = {
    id: '10',
    type: 'template',
    title: 'Marketing Template Pack',
    description: 'Pack of templates for marketing campaigns.',
    authorId: '2',
    author: exampleUserCreatorProfile3,
    category: 'marketing',
    tags: ['Automation','Graphics','No-Code'],
    thumbnail: '',
    screenshots: [],
    price: 8.5,
    isPremium: false,
    rating: 4,
    ratingCount: 1,
    downloadCount: 14,
    viewCount: 32,
    reviews: [exampleReview3],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-04-01'),
    updatedAt: new Date('2025-04-12'),
    publishedAt: new Date('2025-04-12'),
    metadata: {
      version: 'v1.0',
      compatibility: ['Mac'],
      fileSize: 13,
      lastModified: new Date('2025-04-12')
    }
  };
export let exampleMarketPlaceItem12: MarketplaceItem = {
    id: '11',
    type: 'node',
    title: 'Database Connector Node',
    description: 'Easily connect and query databases.',
    authorId: '3',
    author: exampleUserCreatorProfile4,
    category: 'backend',
    tags: ['API','Backend','Database'],
    thumbnail: '',
    screenshots: [],
    price: 20,
    isPremium: true,
    rating: 3,
    ratingCount: 2,
    downloadCount: 18,
    viewCount: 42,
    reviews: [exampleReview4, exampleReview7],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-03-18'),
    updatedAt: new Date('2025-03-28'),
    publishedAt: new Date('2025-03-28'),
    metadata: {
      version: 'v3.1',
      compatibility: ['Windows','Linux'],
      fileSize: 42,
      lastModified: new Date('2025-03-28')
    }
  };
export let exampleMarketPlaceItem13: MarketplaceItem = {
    id: '12',
    type: 'workflow',
    title: 'PDF Automation Workflow',
    description: 'Automate PDF tasks quickly and efficiently.',
    authorId: '4',
    author: exampleUserCreatorProfile5,
    category: 'productivity',
    tags: ['PDF','Automation','Tools'],
    thumbnail: '',
    screenshots: [],
    price: 7.99,
    isPremium: false,
    rating: 5,
    ratingCount: 1,
    downloadCount: 11,
    viewCount: 29,
    reviews: [exampleReview5],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-02-22'),
    updatedAt: new Date('2025-03-01'),
    publishedAt: new Date('2025-03-01'),
    metadata: {
      version: 'v1.0',
      compatibility: ['Windows','Mac'],
      fileSize: 22,
      lastModified: new Date('2025-03-01')
    }
  };
export let exampleDataItem13: MarketplaceItem = {
    id: '13',
    type: 'template',
    title: 'Marketing Campaign Template',
    description: 'A pre-built template for social media marketing campaigns, easy to customize and deploy.',
    authorId: '1',
    author: exampleUserCreatorProfile2,
    category: 'marketing',
    tags: ['social media', 'campaign', 'template'],
    thumbnail: '',
    screenshots: [],
    price: 9.99,
    isPremium: true,
    rating: 4,
    ratingCount: 5,
    downloadCount: 10,
    viewCount: 50,
    reviews: [exampleReview2, exampleReview9],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-03-15'),
    publishedAt: new Date('2025-01-12'),
    metadata: {
        version: 'v2.1',
        compatibility: ['Web', 'Mobile'],
        fileSize: 15,
        lastModified: new Date('2025-03-14'),
    }
};

export let exampleDataItem14: MarketplaceItem = {
    id: '14',
    type: 'workflow',
    title: 'Automated Invoice Generator',
    description: 'Workflow to automatically generate invoices from spreadsheet data and export PDFs.',
    authorId: '0',
    author: exampleUserCreatorProfile1,
    category: 'finance',
    tags: ['invoice', 'automation', 'PDF'],
    thumbnail: '',
    screenshots: [],
    price: 0,
    isPremium: false,
    rating: 5,
    ratingCount: 7,
    downloadCount: 15,
    viewCount: 60,
    reviews: [exampleReview1, exampleReview6],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-02-05'),
    updatedAt: new Date('2025-04-01'),
    publishedAt: new Date('2025-02-07'),
    metadata: {
        version: 'v1.3',
        compatibility: ['Windows', 'MacOS'],
        fileSize: 25,
        lastModified: new Date('2025-03-31'),
    }
};

export let exampleDataItem15: MarketplaceItem = {
    id: '15',
    type: 'node',
    title: 'AI Text Summarizer Node',
    description: 'Node for summarizing text using AI models, perfect for research and productivity apps.',
    authorId: '5',
    author: exampleUserCreatorProfile6,
    category: 'AI',
    tags: ['AI', 'text', 'summarizer'],
    thumbnail: '',
    screenshots: [],
    price: 19.99,
    isPremium: true,
    rating: 4,
    ratingCount: 4,
    downloadCount: 7,
    viewCount: 40,
    reviews: [exampleReview6, exampleReview11],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-01-20'),
    updatedAt: new Date('2025-03-22'),
    publishedAt: new Date('2025-01-21'),
    metadata: {
        version: 'v1.0',
        compatibility: ['Web', 'NodeJS'],
        fileSize: 18,
        lastModified: new Date('2025-03-20'),
    }
};

export let exampleDataItem16: MarketplaceItem = {
    id: '16',
    type: 'template',
    title: 'Project Management Dashboard',
    description: 'A fully customizable project management dashboard template for teams and freelancers.',
    authorId: '3',
    author: exampleUserCreatorProfile4,
    category: 'productivity',
    tags: ['project', 'dashboard', 'template'],
    thumbnail: '',
    screenshots: [],
    price: 12,
    isPremium: false,
    rating: 3,
    ratingCount: 6,
    downloadCount: 12,
    viewCount: 55,
    reviews: [exampleReview4, exampleReview3],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-03-05'),
    updatedAt: new Date('2025-04-05'),
    publishedAt: new Date('2025-03-06'),
    metadata: {
        version: 'v2.0',
        compatibility: ['Web', 'iOS'],
        fileSize: 22,
        lastModified: new Date('2025-04-04'),
    }
};

export let exampleDataItem17: MarketplaceItem = {
    id: '17',
    type: 'workflow',
    title: 'Email Automation Workflow',
    description: 'A workflow that automatically sends follow-up emails based on user actions and schedules.',
    authorId: '2',
    author: exampleUserCreatorProfile3,
    category: 'communication',
    tags: ['email', 'automation', 'workflow'],
    thumbnail: '',
    screenshots: [],
    price: 10,
    isPremium: true,
    rating: 4,
    ratingCount: 5,
    downloadCount: 8,
    viewCount: 45,
    reviews: [exampleReview3, exampleReview10],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-01-30'),
    updatedAt: new Date('2025-03-12'),
    publishedAt: new Date('2025-02-01'),
    metadata: {
        version: 'v1.5',
        compatibility: ['Web', 'MacOS'],
        fileSize: 20,
        lastModified: new Date('2025-03-10'),
    }
};

export let exampleDataItem18: MarketplaceItem = {
    id: '18',
    type: 'node',
    title: 'PDF Data Extractor Node',
    description: 'Node that extracts structured data from PDF files for processing and reporting.',
    authorId: '0',
    author: exampleUserCreatorProfile1,
    category: 'data',
    tags: ['PDF', 'data', 'node'],
    thumbnail: '',
    screenshots: [],
    price: 16.5,
    isPremium: false,
    rating: 4,
    ratingCount: 6,
    downloadCount: 11,
    viewCount: 48,
    reviews: [exampleReview1, exampleReview5],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-02-15'),
    updatedAt: new Date('2025-03-28'),
    publishedAt: new Date('2025-02-16'),
    metadata: {
        version: 'v1.1',
        compatibility: ['Windows', 'Linux'],
        fileSize: 24,
        lastModified: new Date('2025-03-27'),
    }
};

export let exampleDataItem19: MarketplaceItem = {
    id: '19',
    type: 'template',
    title: 'UX/UI Kit Template',
    description: 'A complete UI kit template for designers to rapidly prototype web and mobile apps.',
    authorId: '7',
    author: exampleUserCreatorProfile8,
    category: 'design',
    tags: ['UI', 'UX', 'template'],
    thumbnail: '',
    screenshots: [],
    price: 13.75,
    isPremium: true,
    rating: 5,
    ratingCount: 5,
    downloadCount: 9,
    viewCount: 42,
    reviews: [exampleReview8, exampleReview2],
    isApproved: true,
    isFeatured: false,
    createdAt: new Date('2025-03-10'),
    updatedAt: new Date('2025-04-10'),
    publishedAt: new Date('2025-03-11'),
    metadata: {
        version: 'v3.0',
        compatibility: ['Web', 'iOS', 'Android'],
        fileSize: 30,
        lastModified: new Date('2025-04-09'),
    }
};

export let exampleDataItem20: MarketplaceItem = {
    id: '20',
    type: 'workflow',
    title: 'Social Media Auto Poster',
    description: 'Automates posting content to multiple social media platforms at scheduled times.',
    authorId: '1',
    author: exampleUserCreatorProfile2,
    category: 'marketing',
    tags: ['social', 'automation', 'workflow'],
    thumbnail: '',
    screenshots: [],
    price: 17.5,
    isPremium: false,
    rating: 5,
    ratingCount: 4,
    downloadCount: 7,
    viewCount: 38,
    reviews: [exampleReview2, exampleReview9],
    isApproved: true,
    isFeatured: true,
    createdAt: new Date('2025-02-25'),
    updatedAt: new Date('2025-03-25'),
    publishedAt: new Date('2025-02-26'),
    metadata: {
        version: 'v1.8',
        compatibility: ['Web', 'Mobile'],
        fileSize: 28,
        lastModified: new Date('2025-03-24'),
    }
};

